/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { deploymentsActive } from "../funcs/deploymentsActive.js";
import { deploymentsCreate } from "../funcs/deploymentsCreate.js";
import { deploymentsEvaluateOpenAPIv3 } from "../funcs/deploymentsEvaluateOpenAPIv3.js";
import { deploymentsEvaluation } from "../funcs/deploymentsEvaluation.js";
import { deploymentsEvolveDeployment } from "../funcs/deploymentsEvolveDeployment.js";
import { deploymentsGetById } from "../funcs/deploymentsGetById.js";
import { deploymentsLatest } from "../funcs/deploymentsLatest.js";
import { deploymentsList } from "../funcs/deploymentsList.js";
import { deploymentsLogs } from "../funcs/deploymentsLogs.js";
import { deploymentsRedeployDeployment } from "../funcs/deploymentsRedeployDeployment.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateDeploymentResult } from "../models/components/createdeploymentresult.js";
import { EvolveResult } from "../models/components/evolveresult.js";
import { GetActiveDeploymentResult } from "../models/components/getactivedeploymentresult.js";
import { GetDeploymentEvaluationResult } from "../models/components/getdeploymentevaluationresult.js";
import { GetDeploymentLogsResult } from "../models/components/getdeploymentlogsresult.js";
import { GetDeploymentResult } from "../models/components/getdeploymentresult.js";
import { GetLatestDeploymentResult } from "../models/components/getlatestdeploymentresult.js";
import { ListDeploymentResult } from "../models/components/listdeploymentresult.js";
import { OpenAPIv3Evaluation } from "../models/components/openapiv3evaluation.js";
import { RedeployResult } from "../models/components/redeployresult.js";
import {
  CreateDeploymentRequest,
  CreateDeploymentSecurity,
} from "../models/operations/createdeployment.js";
import {
  EvaluateOpenAPIv3Request,
  EvaluateOpenAPIv3Security,
} from "../models/operations/evaluateopenapiv3.js";
import {
  EvolveDeploymentRequest,
  EvolveDeploymentSecurity,
} from "../models/operations/evolvedeployment.js";
import {
  GetActiveDeploymentRequest,
  GetActiveDeploymentSecurity,
} from "../models/operations/getactivedeployment.js";
import {
  GetDeploymentRequest,
  GetDeploymentSecurity,
} from "../models/operations/getdeployment.js";
import {
  GetDeploymentEvaluationRequest,
  GetDeploymentEvaluationSecurity,
} from "../models/operations/getdeploymentevaluation.js";
import {
  GetDeploymentLogsRequest,
  GetDeploymentLogsSecurity,
} from "../models/operations/getdeploymentlogs.js";
import {
  GetLatestDeploymentRequest,
  GetLatestDeploymentSecurity,
} from "../models/operations/getlatestdeployment.js";
import {
  ListDeploymentsRequest,
  ListDeploymentsSecurity,
} from "../models/operations/listdeployments.js";
import {
  RedeployDeploymentRequest,
  RedeployDeploymentSecurity,
} from "../models/operations/redeploydeployment.js";
import { unwrapAsync } from "../types/fp.js";

export class Deployments extends ClientSDK {
  /**
   * getActiveDeployment deployments
   *
   * @remarks
   * Get the active deployment for a project.
   */
  async active(
    request?: GetActiveDeploymentRequest | undefined,
    security?: GetActiveDeploymentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetActiveDeploymentResult> {
    return unwrapAsync(deploymentsActive(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createDeployment deployments
   *
   * @remarks
   * Create a deployment to load tool definitions.
   */
  async create(
    request: CreateDeploymentRequest,
    security?: CreateDeploymentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreateDeploymentResult> {
    return unwrapAsync(deploymentsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * evaluateOpenAPIv3 deployments
   *
   * @remarks
   * Compare an uploaded OpenAPI document with the version of the same source in the active deployment. Reports changes to tools, inputs and security without deploying anything.
   */
  async evaluateOpenAPIv3(
    request: EvaluateOpenAPIv3Request,
    security?: EvaluateOpenAPIv3Security | undefined,
    options?: RequestOptions,
  ): Promise<OpenAPIv3Evaluation> {
    return unwrapAsync(deploymentsEvaluateOpenAPIv3(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getDeploymentEvaluation deployments
   *
   * @remarks
   * Compare the OpenAPI documents in a deployment with the deployment it was created from.
   */
  async evaluation(
    request: GetDeploymentEvaluationRequest,
    security?: GetDeploymentEvaluationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetDeploymentEvaluationResult> {
    return unwrapAsync(deploymentsEvaluation(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * evolve deployments
   *
   * @remarks
   * Create a new deployment with additional or updated tool sources.
   */
  async evolveDeployment(
    request: EvolveDeploymentRequest,
    security?: EvolveDeploymentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<EvolveResult> {
    return unwrapAsync(deploymentsEvolveDeployment(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getDeployment deployments
   *
   * @remarks
   * Get a deployment by its ID.
   */
  async getById(
    request: GetDeploymentRequest,
    security?: GetDeploymentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetDeploymentResult> {
    return unwrapAsync(deploymentsGetById(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getLatestDeployment deployments
   *
   * @remarks
   * Get the latest deployment for a project.
   */
  async latest(
    request?: GetLatestDeploymentRequest | undefined,
    security?: GetLatestDeploymentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetLatestDeploymentResult> {
    return unwrapAsync(deploymentsLatest(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDeployments deployments
   *
   * @remarks
   * List all deployments in descending order of creation.
   */
  async list(
    request?: ListDeploymentsRequest | undefined,
    security?: ListDeploymentsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDeploymentResult> {
    return unwrapAsync(deploymentsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getDeploymentLogs deployments
   *
   * @remarks
   * Get logs for a deployment.
   */
  async logs(
    request: GetDeploymentLogsRequest,
    security?: GetDeploymentLogsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetDeploymentLogsResult> {
    return unwrapAsync(deploymentsLogs(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * redeploy deployments
   *
   * @remarks
   * Redeploys an existing deployment.
   */
  async redeployDeployment(
    request: RedeployDeploymentRequest,
    security?: RedeployDeploymentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RedeployResult> {
    return unwrapAsync(deploymentsRedeployDeployment(
      this,
      request,
      security,
      options,
    ));
  }
}
